import ReactDOM from 'react-dom'
import { createRef } from 'react'
import {
  createBrowserRouter,
  RouterProvider,
  useLocation,
  useOutlet,
} from 'react-router-dom'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import Header from './components/header'
// import './components/header.css'

// import '../public/fonts/open-sans.ttf'
// import '../public/fonts/lucida-fax.ttf'
import './style.css'
import './views/gallery.css'
import FAQs from './views/faqs'
import Home from './views/home'
import Gallery from './views/gallery'
import ScrollToTop from './components/plugins/scrollToTop'

// Suppress ResizeObserver loop error (benign warning)
const resizeObserverErr = (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation()
  }
}
window.addEventListener('error', resizeObserverErr)


const App = () => {
  const location = useLocation()
  const currentOutlet = useOutlet()
  const { nodeRef } = routes.find((route) => route.path === location.pathname) ?? {}
  
  return (
    <>
      <ScrollToTop />
      <Header />
      <SwitchTransition>
        <CSSTransition
          key={location.pathname}
          nodeRef={nodeRef}
          timeout={1000}
          appear={true}
          classNames="fade"
          unmountOnExit
        >
          {(state) => (
            <div ref={nodeRef} className="page">
              {currentOutlet}
            </div>
          )}
        </CSSTransition>
      </SwitchTransition>
    </>
  )
}

const routes = [
  { path: '/', name: 'Home', element: <Home />, nodeRef: createRef() },
  { path: '/faqs', name: 'FAQs', element: <FAQs />, nodeRef: createRef() },
  { path: '/gallery', name: 'Gallery', element: <Gallery />, nodeRef: createRef() },
]

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: routes.map((route) => ({
      index: route.path === '/',
      path: route.path === '/' ? undefined : route.path,
      element: route.element,
    })),
  },
])

ReactDOM.render(<RouterProvider router={router} />, document.getElementById('app'))
